import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { CheckTutorial } from './providers/check-tutorial.service';


const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'account',
    loadChildren: () => import('./pages/account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'support',
    loadChildren: () => import('./pages/support/support.module').then(m => m.SupportModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'app',
    loadChildren: () => import('./pages/tabs-page/tabs-page.module').then(m => m.TabsModule)
  },
  {
    path: 'add-to-cart',
    loadChildren: () => import('./pages/add-to-cart/add-to-cart.module').then( m => m.AddToCartPageModule)
  },
  {
    path: 'product-filter',
    loadChildren: () => import('./pages/product-filter/product-filter.module').then( m => m.ProductFilterPageModule)
  },
  {
    path: 'orders',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/orders/orders.module').then( m => m.OrdersPageModule)
      },
      {
        path: 'order/:order',
          loadChildren: () => import('./pages/order/order.module').then( m => m.OrderPageModule)
      }
    ]
  },
  {
    path: 'order',
    loadChildren: () => import('./pages/order/order.module').then( m => m.OrderPageModule)
  },
  {
    path: 'visits',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/visits/visits.module').then( m => m.VisitsPageModule)
      },
      {
        path: 'visit/:visit',
          loadChildren: () => import('./pages/visit/visit.module').then( m => m.VisitPageModule)
      }
    ]
  },
  {
    path: 'visit',
    loadChildren: () => import('./pages/visit/visit.module').then( m => m.VisitPageModule)
  },
  {
    path: 'therapies',
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/therapies/therapies.module').then( m => m.TherapiesPageModule)
      },
      {
        path: 'therapy/:therapy',
          loadChildren: () => import('./pages/therapy/therapy.module').then( m => m.TherapyPageModule)
      }
    ]

  },
  {
    path: 'therapy',
    loadChildren: () => import('./pages/therapy/therapy.module').then( m => m.TherapyPageModule)
  },
  {
    path: 'visit-schedule',
    loadChildren: () => import('./pages/visit-schedule/visit-schedule.module').then( m => m.VisitSchedulePageModule)
  },
  {
    path: 'notifications',
    loadChildren: () => import('./pages/notifications/notifications.module').then( m => m.NotificationsPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'notification',
    loadChildren: () => import('./pages/notification/notification.module').then( m => m.NotificationPageModule)
  },
  {
    path: 'contact',
    loadChildren: () => import('./pages/contact/contact.module').then( m => m.ContactPageModule)
  },
  {
    path: 'agenda-iv',
    loadChildren: () => import('./pages/agenda-iv/agenda-iv.module').then( m => m.AgendaIVPageModule)
  },
  {
    path: 'agenda-inyecciones',
    loadChildren: () => import('./pages/agenda-inyecciones/agenda-inyecciones.module').then( m => m.AgendaInyeccionesPageModule)
  },
  {
    path: 'paciente',
    loadChildren: () => import('./pages/paciente/paciente.module').then( m => m.PacientePageModule  )
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
